import BinIcon from "assets/icons/bin.svg?react";
import { RefObject, useContext, useEffect, useRef, useState } from "react";

import { useOnClickOutside } from "hooks/useClickOutside";

import OptionsCard from "components/OptionsCard/OptionsCard";
import { Option } from "components/OptionsCard/typings";

import chatService from "api/chatService";
import { IChatMessage } from "dto/Chat/IChatMessage";
import ChatMessagesContext from "contexts/ChatMessagesContext";
import { useTranslation } from "react-i18next";

const ChatMessageOptions = ({
  refWrapper,
  message,
  showOptions,
  toggle,

  rightSide = true,
  dropdown = false,
  isRightClicked = false,
}: {
  refWrapper: RefObject<HTMLDivElement>;
  message: IChatMessage;
  showOptions: boolean;
  toggle?: () => void;
  rightSide?: boolean;
  dropdown?: boolean;
  isRightClicked?: boolean;
}) => {
  const { t } = useTranslation();
  const { mutate: deleteMessage } = chatService.useDeleteMessage();
  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (showOptions) {
      toggle?.();
    }
  });

  const { messages, setMessages } = useContext(ChatMessagesContext);

  const handleClicke = () => {
    // if (e.code === "Delete" && showOptions) {
    //   handleDeleteCase();
    // }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleClicke);

    return () => {
      window.removeEventListener("keydown", handleClicke);
    };
  }, [showOptions]);

  const handleDelete = (force?: boolean) => { // eslint-disable-line @typescript-eslint/no-unused-vars
    const newChats = [...messages];

    deleteMessage(message?.Id, {
      onSuccess: () => {
        setMessages(newChats.filter((p) => p.Id !== message.Id));
      },
      onError: () => {},
    });
  };

  const [out, setOut] = useState<Option[]>([]);

  useEffect(() => {
    if (!message) return;

    let options: Option[] = [
      {
        Icon: BinIcon,
        additional: true,
        callback: () => {
          handleDelete();
        },
        canMultiple: true,
        isEnabled: true,
        name: t("chat.deleteMessage"),
      },
    ];

    if (rightSide) {
      options = options.map((op) => {
        op.additional = true;

        return op;
      });
    }

    setOut(options);
  }, [message]);

  if (!message) return <></>;

  return (
    <>
      <OptionsCard
        onClickAttachIcon={() => {}}
        refetch={() => {}}
        selectedElements={[]}
        toggle={toggle}
        showOptions={true}
        rightSide={rightSide}
        refWrapper={refWrapper}
        outsideOptions={out}
        dropdown={dropdown}
        isRightClicked={isRightClicked}
        size="small"
      />
    </>
  );
};

export default ChatMessageOptions;
